import { useTranslation } from 'react-i18next';
import { useNavigate } from '@tanstack/react-router';
import { BUSINESS_IDENTIFIER } from '@modules/core/api/const';
import { Flex } from '@huspy/briks-web';
import MainContentPageWrapper from '@components/v2/MainContentPageWrapper';
import CredentiallessEmbed from '@components/v2/CredentiallessEmbed';

const BANK_UPDATES_URL = 'https://coda.io/embed/lFEq940IWM?viewMode=embedplay';

const BankUpdates = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  if (APPLICATION_BUSINESS_IDENTIFIER !== BUSINESS_IDENTIFIER.AE_HUSPY) {
    navigate({ to: '/' });
  }

  return (
    <MainContentPageWrapper title={ t('bankUpdates.title') }>
      <Flex direction='column' w='100%'>
        <CredentiallessEmbed url={ BANK_UPDATES_URL } title={ t('bankUpdates.title') } />
      </Flex>
    </MainContentPageWrapper>
  );
};

export default BankUpdates;
